export const APP_FONT_FAMILY = "'Anuphan', sans-serif";
